import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Alert } from "@material-ui/lab";
import { CLASSIC_NO_TAX_OUTCOME_TEXTS } from "./classicOutcomeTexts";

const OUTCOME_STYLE = {
  width: "100%",
  boxSizing: "border-box",
  direction: "rtl",
  textAlign: "right",
  alignItems: "flex-start"
};
const TITLE_STYLE = { fontWeight: 800 };
const REPORTING_NOTE_STYLE = { marginTop: 8 };

const useStyles = makeStyles({
  alert: {
    "& .MuiAlert-icon": {
      marginLeft: 12,
      marginRight: 0
    }
  }
});

const ClassicNoTaxOutcome = () => {
  const classes = useStyles();

  return (
    <Alert className={`${classes.alert} haklai-no-tax-outcome`} severity="success" style={OUTCOME_STYLE}>
      <Typography variant="h6" style={TITLE_STYLE}>
        {CLASSIC_NO_TAX_OUTCOME_TEXTS.title}
      </Typography>
      <Typography variant="body1">
        {CLASSIC_NO_TAX_OUTCOME_TEXTS.explanation}
      </Typography>
      <Typography variant="body2" style={REPORTING_NOTE_STYLE}>
        {CLASSIC_NO_TAX_OUTCOME_TEXTS.reportingNote}
      </Typography>
    </Alert>
  );
};

export default React.memo(ClassicNoTaxOutcome);
